import React from 'react';
import styles from './AIRca.module.css';

/**
 * Skeleton placeholder shown while fetching an ALREADY-generated RCA (as
 * opposed to RCAProgressiveLoader, which is used only during live generation).
 * Mirrors the RCA content layout — a summary/category card, an "Event Timeline"
 * heading, and a few timeline rows — with a shimmer, so the transition into the
 * real content feels seamless.
 */
const TIMELINE_ROWS = [0, 1, 2, 3];

const RCASkeletonLoader = () => (
  <div className={styles.rcaSkeleton} aria-hidden="true" data-testid="rca-skeleton">
    <div className={styles.skelCard}>
      <div className={`${styles.skelLine} ${styles.skelW40}`} />
      <div className={`${styles.skelLine} ${styles.skelW90}`} />
      <div className={`${styles.skelLine} ${styles.skelW75}`} />
    </div>

    <div className={`${styles.skelHeading} ${styles.skelW30}`} />

    <div className={styles.skelTimeline}>
      {TIMELINE_ROWS.map((row) => (
        <div key={row} className={styles.skelRow}>
          <div className={styles.skelDot} />
          <div className={styles.skelRowText}>
            <div className={`${styles.skelLine} ${styles.skelW60}`} />
            <div className={`${styles.skelLine} ${styles.skelW85}`} />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default RCASkeletonLoader;
